import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock, Users, Trophy,
  Zap, AlertTriangle
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo8 from "@assets/logos_extracted/8.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://csn.fynkelto.com/?mid=279656_1645832";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Moderní a přehledný design",
  "Velký výběr automatů a živého kasina",
  "Dostupné sportovní sázení",
  "Štědré bonusy a pravidelné akce",
  "Podpora kryptoměn",
  "Optimalizováno pro mobilní zařízení",
];

const cons = [
  "Občasné zpoždění výběrů",
  "Vyšší požadavky na protočení bonusů",
  "Nejednotná kvalita zákaznické podpory",
  "Bez samostatné mobilní aplikace",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Počet metod:</span><span className={valueClass}>71 platebních možností</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky:</span><span className={valueClass}>Žádné poplatky ze strany kasina</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <span className={valueClass}>Visa, Mastercard, bankovní převod, Skrill, Neteller, předplacené karty, vybrané kryptoměny, e-peněženky</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <span className={valueClass}>Visa, Mastercard, bankovní převod, Skrill, Neteller, e-peněženky, kryptoměny</span>
        </div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>e-peněženky rychleji; bankovní převod déle; závisí na KYC stavu</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>7 500+ titulů (75+ poskytovatelů)</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – klasické, Megaways, jackpoty, bonus-buy</span></div>
        <div className={rowClass}><span className={labelClass}>Stolní hry:</span><span className={valueClass}>Ruleta, blackjack, baccarat, video poker</span></div>
        <div className={rowClass}><span className={labelClass}>Živé kasino:</span><span className={valueClass}>Ano – ruleta s krupiérem, blackjack, game shows</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – předzápasové kurzy i live sázky</span></div>
        <div className={rowClass}><span className={labelClass}>E-sporty:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Demo režim:</span><span className={valueClass}>Ano – u většiny her</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>24/7</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano – dostupný v češtině</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>Ano – odpověď obvykle do jednoho dne</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyk podpory:</span><span className={valueClass}>Čeština a další jazyky</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://www.casinia.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">casinia.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2017</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky:</span><span className={valueClass}>Čeština, Angličtina, Němčina, Finština, Maďarština, Norština, Polština, Italština, Španělština a další</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Bez nativní aplikace – plně responzivní web</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – v rámci jednoho účtu</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Časové připomínky:", "Ano"],
      ["Dočasné přerušení hry:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["KYC ověření:", "Povinné při výběrech"],
      ["Demo režim:", "Ano"],
      ["VIP program:", "Ano – cashback až 15 %"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={`${valueClass} ${value === "Ano" ? "text-green-600" : value === "Ne" ? "text-gray-400" : "text-gray-900"}`}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function CasiniaPage() {
  useSEO({ title: "Casinia Casino Recenze 2026 – Bonus a 3000+ slotů | HrajBonus", description: "Nezávislá recenze Casinia Casino. Velký výběr slotů, live her a bonusů. Licencované kasino s rychlými výplatami. Hodnocení 8.7/10. 18+",
  url: "https://hrajbonus.com/kasina/casinia", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllPayments, setShowAllPayments] = useState(false);

  const paymentList = [
    "Visa", "Mastercard", "Bankovní převod", "Skrill", "Neteller",
    "Paysafecard", "MiFinity", "Jetonbank", "Bitcoin", "Ethereum",
    "Litecoin", "USDT TRC20", "USDT ERC20", "Solana", "Ripple",
    "Dogecoin", "Bitcoin Cash", "Cardano", "Revolut", "PlayID",
  ];
  const visiblePayments = showAllPayments ? paymentList : paymentList.slice(0, 10);

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo8} alt="Casinia logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Casinia</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 29/01/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",        value: "11 000+" },
                    { label: "Minimální vklad",  value: "250 Kč" },
                    { label: "Minimální výběr",  value: "250 Kč" },
                    { label: "Licence",          value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 25 000 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>

            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Casinia" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.0</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Casinia Casino přináší moderní online casino prostředí zaměřené na jednoduchost, rychlost a pohodlí hráčů. Casinia sází na přehledný design, bohatou nabídku her a svižné zpracování plateb, což z něj dělá atraktivní volbu pro nové i zkušenější hráče. Celkový dojem je profesionální a vyvážený, přičemž kasino splňuje očekávání, která dnes od kvalitní online platformy máme.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Quick stats table */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-5">
                  Casinia cz: recenze a hodnocení
                </h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Když se řekne Casinia cz, mnoho českých hráčů si vybaví přehledné rozhraní v češtině, tisíce her a bonus, který umí zvednout rozpočet na startu. Při bližším pohledu je ale důležité, jak se platforma chová v praxi: rychlost výběrů, stabilita webu, kvalita podpory a jasně napsaná pravidla. V pěkném kabátě totiž často leží drobnosti, které rozhodují o celkové spokojenosti.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Níže najdete kompletní pohled na to, co Casinia umí, kde září a kde ještě zbývá prostor k vylepšení. Vycházíme z veřejně dostupných českých a slovenských recenzí i ze zkušeností dlouhodobých uživatelů.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-4">Rychlý přehled v číslech a faktech</h3>
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Parametr</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Hodnota</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Licence", "Curacao"],
                        ["Jazyk rozhraní", "Čeština"],
                        ["Počet her", "7 500+ titulů"],
                        ["Počet poskytovatelů", "75+ studií"],
                        ["Uvítací bonus", "100 % až 12 500 Kč + 200 volných zatočení + bonus Crab"],
                        ["Promo akce", "Reload, týdenní cashback, věrnostní úrovně"],
                        ["Zákaznická podpora", "24/7 chat a e-mail, bez telefonu"],
                        ["Platební metody", "71 možností včetně karet, e-peněženek a kryptoměn"],
                        ["Mobilní hraní", "Bez samostatné aplikace, responzivní mobilní web"],
                        ["Další sekce", "Sportovní sázení a live sázky"],
                        ["Reputace v recenzích", "4,0/5 (CZ portál), 4,3/5 (SK portál), index 8,6/10"],
                      ].map(([param, value], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-medium text-gray-700 text-xs">{param}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-500 text-xs mt-3 leading-relaxed">
                  Čísla napovídají, že jde o velké mezinárodní online kasino s nabídkou, která přesahuje běžný standard. Hodně pozornosti přitahuje podpora kryptoměn a široká paleta e-peněženek. V českém kontextu zaujme i kompletní lokalizace a živý chat v češtině.
                </p>
              </div>

              {/* Games lobby */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Lobby, kategorie a jak se v Casinia hraje</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Po přihlášení vás čeká čisté rozhraní, které dává smysl hned na první klik. Kategorie jsou přeložené, filtry fungují svižně a vyhledávání zvládá jak názvy her, tak i jména studií. Díky tomu se dá během pár vteřin skočit do oblíbené hry, nebo naopak zkusit něco nového.
                </p>
                <div className="space-y-2 mb-5">
                  {[
                    "Automaty: od tříválcové klasiky až po Megaways systémy a novinky s jackpoty",
                    "Stolní hry: ruleta, blackjack, baccarat, video poker a jejich varianty",
                    "Živé hry: ruleta s krupiérem, blackjack stoly s různými limity, game show režimy",
                    "Sport: předzápasové kurzy i live sázky, rychlé lístky a přehled výsledků",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 leading-relaxed text-sm">
                  Nabídka přes 7 tisíc titulů od více než 75 poskytovatelů se projeví hlavně v rozmanitosti témat a mechanik. Nejde jen o kvantitu, ale i o to, že katalog zahrnuje jak mainstreamové hity, tak menší studia s netradičním pojetím.
                </p>

                <div className="mt-5 bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Živé kasino a sportovní sekce</div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">
                    Živé stoly v Casinia působí moderně. Na výběr bývá několik variant pro rozdílné rozpočty, nechybí europoruleta, VIP stoly a herní show pro ty, kteří mají rádi větší interakci a tempo. Streamy jedou stabilně, přepínání stolů je rychlé a české rozhraní ulehčuje orientaci.
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Sportovní sázky doplňují kasinovou část o další rozměr. Pro mnoho hráčů je příjemné mít vše pod jednou střechou: v praxi to znamená, že můžete kombinovat večer u automatů se live sázením na hokej či fotbal, aniž by bylo nutné přecházet na jiný web.
                  </p>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy: co potěší a na co si dát pozor</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Uvítací nabídka patří k hlavním magnetům. Kombinace 100 % až do 12 500 Kč a 200 volných zatočení je v recenzích zmiňovaná jako štědrá a patří mezi vyšší standard mezinárodních značek. K tomu se přidává takzvaný bonus Crab, který doplňuje hlavní balíček.
                </p>

                <div className="grid sm:grid-cols-2 gap-5 mb-5">
                  <div className="bg-green-50 border border-green-100 rounded-xl p-4">
                    <div className="font-bold text-green-700 text-sm mb-2">Co hráči oceňují:</div>
                    <ul className="space-y-1.5">
                      {[
                        "Transparentní popis bonusu v rozhraní",
                        "Free spiny rozdělené do více dní, které prodlouží zábavu",
                        "Reálná šance si zahrát dlouho i s menším vkladem",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                          <CheckCircle className="w-3.5 h-3.5 text-green-600 mt-0.5 flex-shrink-0" /> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="bg-amber-50 border border-amber-100 rounded-xl p-4">
                    <div className="font-bold text-amber-700 text-sm mb-2">Co je dobré číst předem:</div>
                    <ul className="space-y-1.5">
                      {[
                        "Požadavek na protočení bývá kolem 35× u bonusových peněz",
                        "Některé stoly a živé hry se do podmínek počítají méně, případně vůbec",
                        "Maximální sázka může být u bonusu limitovaná",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                          <AlertTriangle className="w-3.5 h-3.5 text-amber-600 mt-0.5 flex-shrink-0" /> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Kromě uvítací nabídky běží průběžné akce. Ty obvykle zahrnují víkendové nebo týdenní reload bonusy a cashback. U cashbacku recenze zmiňují, že plná nabídka se často otevírá až vyšším úrovním věrnostního programu. Pokud sází spíše rekreační hráč, stojí za to hlídat promo kalendář a vyzvednout si bonusy, které se dají rozumně splnit během pár sezení.
                </p>

                <div className="grid sm:grid-cols-2 gap-2 mb-5">
                  {["Uvítací balíčky", "Cashback", "Reload bonusy", "Free spiny", "VIP program", "Speciální sportovní akce"].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <Trophy className="w-4 h-4 text-[#c9960f] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>

                <h3 className="font-bold text-gray-900 text-base mb-3">Věrnostní program a cashback</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  VIP úrovně přidávají dlouhodobé benefity. Jde hlavně o:
                </p>
                <div className="grid sm:grid-cols-2 gap-2 mb-3">
                  {[
                    "Vyšší limity výběrů",
                    "Individuální promo nabídky",
                    "Osobního manažera u nejvyšších úrovní",
                    "Cashback až do 15 % u vybraných tiers",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm italic">
                  Smysl to dává hlavně hráčům, kteří v kasinu tráví více času. Pokud chodíte jen občas, vyplatí se spíš krátkodobé akce a free spiny.
                </p>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Vklady, výběry a limity</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Casinia patří mezi platformy, které nabízejí hodně platebních cest. V praxi to znamená:
                </p>
                <div className="space-y-2 mb-5">
                  {[
                    "Karty Visa a MasterCard",
                    "Bankovní převod",
                    "E-peněženky včetně oblíbených služeb typu Skrill nebo Neteller",
                    "Předplacené karty",
                    "Vybrané kryptoměny",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CreditCard className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Platební metody (71 možností)</div>
                  <div className="flex flex-wrap gap-1.5">
                    {visiblePayments.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {paymentList.length > 10 && (
                      <button onClick={() => setShowAllPayments(!showAllPayments)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllPayments ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{paymentList.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-4">
                  <p className="text-amber-800 text-sm leading-relaxed">
                    <span className="font-bold">Důležité:</span> Recenze vyzdvihují rychlé zpracování transakcí a stabilitu platební brány. Pozornost si ale zaslouží týdenní a měsíční limity na výběry. Ty mohou u některých účtů držet tempo výplat při větších výhrách, zvlášť u nižších VIP úrovní. Doporučení je jednoduché: ještě před prvním vkladem si projděte stránku plateb a limity pro svůj region. Ušetří to překvapení při prvním výběru.
                  </p>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed">
                  KYC ověření je standard. Počítejte s tím, že při vyšších částkách nebo při prvním výběru bude potřeba doložit doklad totožnosti a někdy i potvrzení adresy. Čím rychleji nahrané dokumenty projdou, tím hladší bude další průběh.
                </p>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora a česká lokalizace</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Podpora běží nepřetržitě přes chat a e-mail. Live chat je dostupný v češtině, což je znát na rychlosti dorozumění i na srozumitelnosti odpovědí. E-mailové dotazy se zpravidla řeší v rámci jednoho dne. Telefonická linka chybí, což někomu nevadí, jinému ano.
                </p>
                <div className="grid sm:grid-cols-2 gap-3 mb-5">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat v češtině</div>
                      <div className="text-green-600 text-xs">24/7 dostupný</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">Odpověď do 1 dne</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">Není k dispozici</div>
                    </div>
                  </div>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  Zpětná vazba od hráčů bývá převážně pozitivní, občas se ale objeví dva typy zkušeností:
                </p>
                <ul className="space-y-1.5 mb-4">
                  {[
                    "Formální odpovědi u složitějších dotazů",
                    "Delší čekání na vyřízení požadavku přes e-mail",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <span className="text-gray-400 mt-0.5 flex-shrink-0">▬</span> {item}
                    </li>
                  ))}
                </ul>
                <p className="text-gray-500 text-sm leading-relaxed">
                  U běžných situací, jako je ověření účtu, otázky k bonusu či technické potíže s konkrétní hrou, chat pomáhá rychle a srozumitelně. Pokud řešíte výjimky z podmínek bonusu nebo nestandardní transakci, dejte podpoře jasné časové označení kroků a přiložte screenshoty, komunikace se tím zrychlí.
                </p>
              </div>

              {/* Mobile */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Mobilní hraní bez aplikace</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Samostatná mobilní aplikace k dispozici není. Web je ale postavený responzivně a běží svižně i na starších telefonech. Hry se načítají přes celou obrazovku, ovládací prvky jsou upravené pro dotyk a důležité prvky rozhraní zůstávají po ruce.
                </p>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Když porovnáte mobilní web s nativní aplikací, rozdíl ucítíte hlavně v notifikacích a přihlášení na jedno klepnutí. Pokud chcete mít promo upozornění po ruce, je dobré si povolit e-maily nebo pravidelně navštěvovat promo stránku.
                </p>
              </div>

              {/* No-license warning */}
              <div className="bg-amber-50 border border-amber-300 rounded-2xl p-5 flex gap-3" data-testid="license-warning">
                <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-bold text-amber-800 text-sm mb-1">Důležitá poznámka k licenci</div>
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Casinia cz funguje s mezinárodní licencí Curacao. Z pohledu českého práva ale nejde o subjekt s národní licencí, proto se vždy vyplatí číst pravidla a podmínky pro svůj region a měnu. Bez české licence nejde o legální sázení pro rezidenty ČR v rámci přísné interpretace zákona. Pokud je pro vás česká státní licence klíčová, volte regulované operátory.
                  </p>
                </div>
              </div>

              {/* Sports section */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Sportovní sázky v jednom účtu</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Velkým benefitem je, že Casinia kombinuje kasino a sázkovku. Lze tak jedním zůstatkem přecházet mezi sloty a live zápasy. Nabídka trhů pokrývá hlavní sporty, e-sporty i speciální příležitosti. Pro hráče zvyklé na české prostředí to může být příjemné, i když tuzemští licencovaní provozovatelé mívají sportovní sázky oddělené.
                </p>
                <div className="grid sm:grid-cols-3 gap-2">
                  {["Předzápasové kurzy", "Live sázky", "E-sporty", "Rychlé lístky", "Přehled výsledků", "Sdílená peněženka kasino + sport"].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Independent ratings */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak si Casinia stojí v nezávislých hodnoceních</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Veřejné recenze hodnotí Casinii nadprůměrně. Český specializovaný portál jí dává celkové skóre 4,0 z 5. Slovenský portál udává 4,3 z 5 a plných 5 z 5 za šíři her. Důvěryhodnostní index na mezinárodní platformě dosahuje 8,6 z 10 s pochvalou za férové podmínky bez nepřiměřených klauzulí.
                </p>
                <div className="grid sm:grid-cols-3 gap-3 mb-4">
                  {[
                    { source: "CZ portál",             score: "4,0/5",   note: "Celkové hodnocení" },
                    { source: "SK portál",             score: "4,3/5",   note: "5/5 za šíři her" },
                    { source: "Mezinárodní platforma", score: "8,6/10",  note: "Férovost podmínek" },
                  ].map(({ source, score, note }) => (
                    <div key={source} className="bg-[#f3f6fb] rounded-xl p-3 text-center">
                      <div className="text-[#003da5] font-black text-xl">{score}</div>
                      <div className="text-gray-700 font-semibold text-xs mt-0.5">{source}</div>
                      <div className="text-gray-400 text-xs">{note}</div>
                    </div>
                  ))}
                </div>
                <div className="space-y-1.5">
                  {[
                    "Katalog her patří mezi největší lákadla",
                    "Bonusy a promo kalendář jsou nadprůměrné",
                    "Dílčí výtky míří na absenci telefonu, omezenou aplikaci a limity výběrů",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Practical tips */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Praktické tipy, které ušetří čas a nervy</h2>
                <div className="space-y-3">
                  {[
                    ["Zkontrolujte podmínky bonusu ještě před vkladem.", "Zaměřte se na protočení, váhu her, maximální sázku a dobu platnosti."],
                    ["Ověřte účet hned po registraci.", "Vyhnete se prodlevám u prvního výběru."],
                    ["Nastavte si vlastní limity.", "Když víte, kolik chcete měsíčně utratit, hra je klidnější."],
                    ["Sledujte promo kalendář.", "Reloady a free spiny bývají časově omezené a snadno utečou."],
                    ["Využívejte chat pro rychlé věci, e-mail pro složitější případy.", "Ke komplikovaným dotazům přidejte čísla transakcí a screenshoty."],
                    ["Pokud hrajete i na mobilu, dejte si Casinia cz do záložek.", "Web je plně responzivní a dostupný bez stahování."],
                  ].map(([tip, desc], i) => (
                    <div key={i} className="flex items-start gap-3">
                      <span className="text-[#003da5] font-black text-sm flex-shrink-0 mt-0.5">{i + 1}.</span>
                      <div>
                        <span className="font-semibold text-gray-900 text-sm">{tip}</span>
                        <span className="text-gray-500 text-sm"> {desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Uživatelská zkušenost */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Uživatelská zkušenost v praxi</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Běžný den v Casinia je z pohledu českého hráče pohodlný. Přihlášení, výběr hry a načtení automatů trvá pár vteřin. Doporučovací dlaždice v lobby dovedou představit nové tituly podle posledních hraných her. Live stoly se spouštějí plynule a přepínání mezi stoly je intuitivní.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Uživatelské rozhraní působí konzistentně na desktopu i na mobilu. Díky češtině se dá spolehnout, že bonusová stránka i platební sekce jsou srozumitelné. Pokud narazíte na něco nejasného, chat většinou reaguje během chvilky.
                </p>

                <div className="mt-5 bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Kdo bude spokojen a pro koho se hodí něco jiného</div>
                  <div className="space-y-2">
                    {[
                      { icon: "✔", text: "Hráč, který chce mít v jednom účtu kasino i sport, ocení kombinaci sekcí a promo akcí." },
                      { icon: "✔", text: "Milovník automatů a objevování novinek využije katalog tisíců titulů a filtry podle studií." },
                      { icon: "✔", text: "Fanoušek e-peněženek a krypta uvidí výhodu v šíři platebních metod a rychlosti převodů." },
                      { icon: "▬", text: "Ten, kdo vyžaduje telefonickou podporu nebo nativní aplikaci, bude spokojený spíš jinde." },
                      { icon: "▬", text: "Pokud je pro vás zásadní česká státní licence, volte podle toho i žebříčky a filtrujte nabídky." },
                    ].map(({ icon, text }, i) => (
                      <div key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                        <span className={`font-bold flex-shrink-0 ${icon === "✔" ? "text-green-500" : "text-gray-400"}`}>{icon}</span>
                        {text}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Časté otázky a stručné odpovědi</h2>
                <div className="space-y-4">
                  {[
                    {
                      q: "Jak rychle probíhají výběry?",
                      a: "Záleží na zvolené metodě a stavu ověření účtu. Po dokončení KYC bývají e-peněženky rychlejší než bankovní převod. Berte v potaz týdenní nebo měsíční limity.",
                    },
                    {
                      q: "Je český jazyk dostupný všude?",
                      a: "Rozhraní kasina ano. U některých živých stolů nebo popisů od poskytovatelů může být jazyk anglický, to je běžné u mezinárodních studií.",
                    },
                    {
                      q: "Jak funguje cashback?",
                      a: "Obvykle se odvíjí od úrovně VIP a objemu sázek v daném období. Podmínky se mohou měnit, sledujte promo stránku a tabulku VIP tierů.",
                    },
                    {
                      q: "Které hry se počítají do protočení bonusu?",
                      a: "Automaty typicky plnou vahou, stolní a živé hry často méně nebo vůbec. Přesný seznam je uvedený u podmínek bonusu.",
                    },
                    {
                      q: "Je sportovní sázení na samostatném účtu?",
                      a: "Ne, kasino a sázky běží v rámci jednoho profilu, sdílejí peněženku a část promo akcí.",
                    },
                  ].map(({ q, a }) => (
                    <div key={q} className="border-b border-[#eef1f7] pb-4 last:border-0 last:pb-0">
                      <div className="font-bold text-gray-900 text-sm mb-1">{q}</div>
                      <p className="text-gray-600 text-sm leading-relaxed">{a}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Final strong/weak */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Silné a slabší stránky přehledně</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="font-bold text-green-700 text-sm mb-3">Výhody:</div>
                    <ul className="space-y-1.5">
                      {[
                        "České prostředí webu a 24/7 chat v češtině",
                        "Přes 7 500 her a desítky poskytovatelů",
                        "Uvítací bonus s vysokým stropem a 200 free spiny",
                        "71 platebních metod včetně krypta a populárních e-peněženek",
                        "Sportovní sázky na stejném účtu",
                        "Stabilní načítání her a rychlá orientace v lobby",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold flex-shrink-0">+</span> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="font-bold text-red-600 text-sm mb-3">Omezení:</div>
                    <ul className="space-y-1.5">
                      {[
                        "Chybí telefonická linka",
                        "Bez nativní mobilní aplikace",
                        "Týdenní a měsíční limity výběrů u vybraných úrovní",
                        "Cashback a některé benefity dostupné od vyšších VIP tierů",
                        "Mezinárodní licence, nikoli česká státní",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold flex-shrink-0">▬</span> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Conclusion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Co z toho plyne pro české hráče</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Casinia je silná volba pro ty, kdo hledají širokou nabídku titulů, české prostředí a přístup ke kryptu i e-peněženkám. Uvítací balíček patří mezi lákavé a dokáže prodloužit herní čas už od prvního vkladu. Zároveň je dobré počítat s tím, že telefonická podpora chybí, mobilní hraní běží přes web a u výběrů platí dané limity.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Pro většinu běžných situací stačí chat v češtině a přehledné rozhraní. Pokud máte rádi pestrost, novinky a možnost přeskakovat mezi automaty, živými stoly a sázením, dává Casinia smysl. Když k tomu přidáte rozumné limity a ověření účtu hned po registraci, získáte stabilní prostředí, ve kterém se hraje pohodlně a bez zbytečných průtahů.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo8} alt="Casinia" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Casinia</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 25 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,      label: "Web",               value: "casinia.com" },
                      { icon: Calendar,   label: "Rok",               value: "2017" },
                      { icon: Lock,       label: "Licence",           value: "Anjouan / Curacao" },
                      { icon: Users,      label: "Provozovatel",      value: "Stellar Ltd" },
                      { icon: Gamepad2,   label: "Počet her",         value: "7 500+ titulů" },
                      { icon: CreditCard, label: "Platební metody",   value: "71 možností" },
                      { icon: Clock,      label: "Podpora",           value: "24/7 Live chat (CZ)" },
                      { icon: Zap,        label: "Min. vklad",        value: "250 Kč" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="casinia" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="review-link-wazamba">Wazamba</a>
              {" · "}
              <a href="/kasina/boaboa" className="text-[#003da5] hover:underline" data-testid="review-link-boaboa">Boaboa</a>
              {" · "}
              <a href="/kasina/spinit" className="text-[#003da5] hover:underline" data-testid="review-link-spinit">SPINiT</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
